// External Imports
import produce from "immer";

// Internal Imports
import { types as authTypes } from "state/auth/types";
import { types } from "./types";

export const initialState = [];

export default function distributors(state = initialState, { type, payload }) {
  return produce(state, (draft) => {
    switch (type) {
      case authTypes.LOGOUT: {
        return initialState;
      }

      case types.SET_DISTRIBUTORS: {
        if (Array.isArray(payload)) {
          return payload;
        }
        break;
      }

      case types.CREATE_DISTRIBUTOR: {
        draft.push(payload);
        break;
      }

      case types.UPDATE_DISTRIBUTOR: {
        let index = draft.findIndex((b) => b.id === payload.id);
        if (index !== -1) {
          draft[index] = { ...draft[index], ...payload };
        }
        break;
      }

      case types.DELETE_DISTRIBUTOR: {
        return draft.filter((b) => b.id !== payload);
      }

      default: {
        return state;
      }
    }
  });
}
